export const openFileInNewTab = (file, onError) => {
    try {
        const url = URL.createObjectURL(file);
        window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
    }
};
